angular.module('jv.quickView', ['ngSanitize', 'videoQuickView', 'jv.Common.Filters', 'jv.candidates.service'])
    .controller('QuickViewCtrl',['$rootScope', 'jvCandidatesService', '$window', '$sce', function($rootScope, candidateService, $window, $sce){
    	
    	$rootScope.app = {};
    	$rootScope.messagesLoading = false;
    	$rootScope.notesLoading = false;
    	$rootScope.app.hasNotes = false;
		$rootScope.app.hasMessages = false;
		
			$rootScope.quickViewMessageListListener = $rootScope.$on('GET_QUICKVIEW_MESSAGE_LIST', function(event, applicationEId, messageCount){
        	if ($rootScope.messagesLoading) {
        		return;  // ensure the listener is not invoked multiple times
        	}
        		
        	$rootScope.messagesLoading = true;
        	
            $rootScope.$broadcast('SHOW_QUICK_VIEW_LOADING');
            candidateService.getMessages({applicationEId:applicationEId}, function(result){
            	$rootScope.app.messages = result.data.messageDataItem;
            	$rootScope.app.messageCount = messageCount;
            	$rootScope.app.hasMessages = result.data.messageDataItem.length > 0;
            	$rootScope.$broadcast('HIDE_QUICK_VIEW_LOADING');
                $rootScope.messagesLoading = false;            	
            });
        });
			$rootScope.quickViewNoteListListener = $rootScope.$on('GET_QUICKVIEW_NOTE_LIST', function(event, applicationEId, noteCount){
        	if ($rootScope.notesLoading) {
        		return;  // ensure the listener is not invoked multiple times
        	}
        		
        	$rootScope.notesLoading = true;

            $rootScope.$broadcast('SHOW_QUICK_VIEW_LOADING');
            candidateService.getNotes({applicationEId:applicationEId}, function(result){
            	$rootScope.app.notes = result.data.messageDataItem;
            	$rootScope.app.noteCount = noteCount;
            	$rootScope.app.hasNotes = result.data.messageDataItem.length > 0;
                $rootScope.$broadcast('HIDE_QUICK_VIEW_LOADING');
                $rootScope.notesLoading = false;
            });
        });
    }]);



